export const DEFAULT_TIMELINE_READ_LIMIT = 5;
export const DEFAULT_SHELF_READ_LIMIT = 20;
export const DEFAULT_ANNOTATION_READ_LIMIT = 20;
export const DEFAULT_SHELF_ITEM_PER_PAGE = 20;
export const DEFAULT_PAPER_SHELF_ITEM_PER_PAGE = 5;



// WEBPACK FOOTER //
// ./common/constants/readingNote.ts